import { __read, __spread } from "tslib";
import { useMemo } from 'react';
import { useRegistry } from './useRegistry';
export function useActions(actionCreators) {
    var registry = useRegistry();
    var names = Object.keys(actionCreators);
    return useMemo(function () {
        return names.reduce(function (mapped, key) {
            mapped[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var action = actionCreators[key].apply(actionCreators, __spread(args));
                registry.dispatch(action);
                return action;
            };
            return mapped;
        }, {});
    }, names);
}
//# sourceMappingURL=useActions.js.map